import React, { useState } from 'react';
import { useSubscriptionConsentContext } from '../../../../context/subscriptionConsent';
import { FilledTextField } from 'components';
import { useIntl } from 'react-intl';
import { validateEmail } from 'shared/utils';

export const EmailInput = () => {
  const { formatMessage } = useIntl();
  const { setEmail, email } = useSubscriptionConsentContext();
  const [emailError, setEmailError] = useState<string | null>(null);
  const [innerValue, setInnerValue] = useState(email);

  const handleEmailChange = (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const email = event.target.value;
    const error = validateEmail(email, formatMessage);
    if (error.email) {
      setEmailError(error.email);
      setEmail('');
      return;
    }
    setEmail(email);
  };

  return (
    <FilledTextField
      fullWidth
      placeholder="example@email.com"
      value={innerValue}
      onChange={(e) => setInnerValue(e.target.value)}
      InputProps={{
        onBlur: handleEmailChange,
        onFocus: () => setEmailError(null),
      }}
      type="email"
      error={!!emailError}
      helperText={emailError}
    />
  );
};
